<template>
  <WdsStack gap-sm direction-column class="filter-full-width">
    <WdsSelect
      v-model="selectedStatuses"
      multi-select
      searchable
      :label="meta.filter.quickFilter ? '' : $t('Status')"
      :list="statusOptions"
      :placeholder="$t('All statuses')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { PaymentRequestStatus } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

type StatusOption = { label: string; value: PaymentRequestStatus }

const model: ModelRef<Array<StatusOption | PaymentRequestStatus>> = defineModel({
  default: () => [],
})

const orderedStatuses = [
  PaymentRequestStatus.Unapproved,
  PaymentRequestStatus.Approved,
  PaymentRequestStatus.Cancelled,
  PaymentRequestStatus.Rejected,
]

const statusLabels: Record<PaymentRequestStatus, string> = {
  [PaymentRequestStatus.Unapproved]: 'Pending',
  [PaymentRequestStatus.Approved]: 'Approved',
  [PaymentRequestStatus.Cancelled]: 'Cancelled',
  [PaymentRequestStatus.Rejected]: 'Rejected',
}

const statusOptions = computed(() =>
  orderedStatuses.map((status) => ({
    label: $t(statusLabels[status]),
    value: status,
  })),
)

const selectedStatuses = computed<StatusOption[]>({
  get() {
    const selected = model.value ?? []
    return selected
      .map((item) => {
        if (item && typeof item === 'object' && 'value' in item) {
          return item as StatusOption
        }
        return statusOptions.value.find((option) => option.value === item)
      })
      .filter((option): option is StatusOption => option !== undefined)
  },
  set(value) {
    model.value = value
  },
})
</script>

